import { formatDate, formatTime, getLocaleDay } from '$lib/utils/date'

export function getDatesObject(date: string, runtime: number = 0, locale = "cs") {
      if (!date) return ''
      const _date = new Date(date)
      let _time = formatTime(_date)

      const _endDate = new Date(_date.valueOf() + runtime * 60 * 1000)

      return {
            endtime: _endDate.valueOf() == _date.valueOf() ? null : formatTime(_endDate),
            time: _time,
            date: formatDate(_date),
            day: getLocaleDay(_date, false, locale),
      }
}

export function getDateTime(item: string, runtime: number = 0, locale = "cs") {
      const d = getDatesObject(item, runtime, locale)
      if (d == '') return ''
      let _dateString = d.day + ' ' + d.date + ' | ' + d.time
      if (d.time != d.endtime && runtime != 0) _dateString += '–' + d.endtime
      return _dateString
}

export function formatCategories(categories) {
      return categories.map((cat) => cat.singular).join(', ')
}

export function authorAggregation(entityArray: any[]) {
      if( ! entityArray ) return ""
      const _authors = entityArray.map((entity) => {
            return entityTitle(entity)
      })
      
      return _authors.join(', ')
}

export function entityAggregation(entityArray: any[]) {
      if( ! entityArray ) return ""
      const _authors = entityArray.map((entity) => {
            return renderEntity(entity)
      })


      return _authors.join(', ')
}

export function addComma(index:number, length:number) {
      return index < length - 1 ? ", " : ""
}

export function renderEntity(entity: any) {
      if (entity.type == 'relation') {
            let _entity = entity?.entity
            if( ! _entity ) return {
                  title: "", url: null
            }
            if( entity?.disableEntityLink == true ) {
              return {
                url: null,
                title: _entity.title
              }
            }

            let href = '/osobnosti/' + _entity?.id
            return {
                  url: href,
                  title: _entity?.title}
      }
      return {
            url: null,
            title: entity?.name
      }
}

function entityLink(entity: any) {
      let _entity = entity?.title
      let href = '/osobnosti/' + entity?.id

      return _entity
}

function entityTitle(entity: any) {
      const type = entity?.type
      if (type == 'text') return entity.name
      if (type == 'relation') {
            return entity.entity?.title
      }
      return 'MISSING'
}

function roleTitle(role: any) {
      if (!role) return ''
      return role.roleName
      const type = role?.type
      if (type == 'text') return role.name
      if (type == 'relation') return role.role?.roleName
      return 'MISSING'
}

export function roleAggregation(roleArray: any[]) {
      const roles = new Map()

      roleArray.map((role) => {
            const _title = roleTitle(role.role)
            const entity = {
                  title: entityTitle(role),
                  _entity: role,
            }

            let _role = roles.get(_title)
            if (!_role) {
                  roles.set(_title, [])
                  _role = roles.get(_title)
            }
            _role.push(entity)
      })

      const _roles = [...roles.entries()].map((role) => ({ role: role[0], names: role[1].map((e) => e.title).join(', '), _entities: role[1].map((e) => e._entity) }))
      //console.log(_roles)

      for (let i = 0; i < _roles.length; i++) {
            const role = _roles[i]
            for (let y = i + 1; y < _roles.length; y++) {
                  const compRole = _roles[y]
                  if (compRole.names == role.names) {
                        role.role += ', ' + compRole.role
                        role._entities = role._entities.concat(compRole._entities)
                        compRole.names = null
                        _roles[i] = role
                        _roles[y] = compRole
                  }
            }
      }
      //console.log(_roles)

      const aggregation = _roles.filter((r) => r.names != null)
      .map( r => {
            const ents: any[] = []
            r._entities.forEach( e => {
                  if( e.type != "relation" ) {
                        const find = ents.find(ent => ent?.text == e?.text)
                        if( find ) return
                        ents.push(e)
                        return
                  }
                  const find = ents.find(ent => ent?.entity?.id == e?.entity?.id)
                  if( find ) return
                  ents.push(e)
            })
            return {
                  ...r,
                  _entities: ents
            }
      })

      return aggregation
}
